import Typography from "@portal/components/atoms/v2/typography";
import { FC } from "react";
import { ISustainabilityOverviewProps } from "./types";
import { TextResources } from "@portal/assets/text/TextResources";
import { GlobeComponent } from "@portal/components/atoms/globe/GlobeComponent";
import PopoverHelpTextLarge from "@portal/components/molecules/popoverHelpTextLarge";

const GetSustainabilityCategoryText = (sfdrRating: number | null) => {
  switch (sfdrRating) {
    case 6:
      return TextResources.FUND_SUSTAINABILITY_CATEGORY_ARTICLE_6;
    case 8:
      return TextResources.FUND_SUSTAINABILITY_CATEGORY_ARTICLE_8;
    case 9:
      return TextResources.FUND_SUSTAINABILITY_CATEGORY_ARTICLE_9;
    default:
      return "";
  }
};

const SustainabilityOverview: FC<ISustainabilityOverviewProps> = ({ morningstarSecuritiesEsg, fund }) => {
  return (
    <ul className="px-2 mt-4 flex flex-col gap-3">
      <li className="flex justify-between items-center gap-2">
        <div>
          <Typography>{TextResources.FUND_SUSTAINABILITY_LABEL}</Typography>
        </div>
        <div className="justify-self-end">
          <GlobeComponent numGlobes={morningstarSecuritiesEsg.sustainabilityRank ?? 0} />
        </div>
      </li>
      <li className="flex justify-between items-center gap-2">
        <div>
          <Typography>{TextResources.FUND_SUSTAINABILITY_LOW_CARBON_LABEL}</Typography>
        </div>
        <div className="justify-self-end">
          <Typography>{morningstarSecuritiesEsg.lowCarbonDesignation ? "Ja" : "Nei"}</Typography>
        </div>
      </li>
      <li className="flex justify-between items-center gap-2">
        <div>
          <Typography>{TextResources.FUND_SUSTAINABILITY_CATEGORY_LABEL}</Typography>
        </div>
        <div className="flex space-x-2 items-center">
          <div className="bg-green text-white px-2 rounded-md">
            <Typography>Artikkel {fund.sfdrRating}</Typography>
          </div>
          <PopoverHelpTextLarge iconSize="small">
            <Typography className="p-2">{GetSustainabilityCategoryText(fund.sfdrRating)}</Typography>
          </PopoverHelpTextLarge>
        </div>
      </li>
      <li className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-1">
          <Typography>{TextResources.FUND_SUSTAINABILITY_CARBON_RISK_SCORE_LABEL}</Typography>
          <PopoverHelpTextLarge iconSize="small">
            <Typography className="p-2">{TextResources.FUND_SUSTAINABILITY_CARBON_RISK_SCORE_HELP_TEXT}</Typography>
          </PopoverHelpTextLarge>
        </div>
        <div className="justify-self-end">
          <Typography>{morningstarSecuritiesEsg.cS_CarbonRiskScore}</Typography>
        </div>
      </li>
      <li className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-1">
          <Typography>{TextResources.FUND_SUSTAINABILITY_ENVIRONMENTAL_RISK_SCORE_LABEL}</Typography>
          <PopoverHelpTextLarge iconSize="small">
            <Typography className="p-2">{TextResources.FUND_SUSTAINABILITY_ENVIRONMENTAL_RISK_SCORE_HELP_TEXT}</Typography>
          </PopoverHelpTextLarge>
        </div>
        <div className="justify-self-end">
          <Typography>{morningstarSecuritiesEsg.environmentalRiskScore}</Typography>
        </div>
      </li>
    </ul>
  );
};

export default SustainabilityOverview;
